import { useOAuthConnect } from '@/hooks/integrations/useOAuthConnect';

export type { DataVisibility } from '@/components/integrations/VisibilityChoiceModal';

export function useGoogleOAuthConnect(orgId: string | undefined) {
  return useOAuthConnect(orgId, 'google');
}
